import React, { useEffect, useState } from "react";
import styles from "./PhoneInputComponent.module.scss";
import HomeServices from "../../pages/home/homeService/HomeService";
import { log } from "console";

interface PhoneInputProps {
  label?: string;
  id: string;
  name: string;
  placeholder?: string;
  value: string;
  error?: string;

  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedCode: string;
  onCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PhoneInputComponent: React.FC<PhoneInputProps> = ({
  label,
  id,
  name,
  placeholder,
  value,
  onChange,
  selectedCode,
  onCodeChange,
  error,
}) => {
  const [phonePrefixes, setPhonePrefixes] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await HomeServices.PhonePrefixData();

        if (res.status && Array.isArray(res.prefix)) {
          const codes = res.prefix.map((item: any) => item.phone_code);
          setPhonePrefixes(codes);
          if (!selectedCode && codes.length > 0) {
            onCodeChange({
              target: { value: codes[0], name: "number_prefix" },
            } as React.ChangeEvent<HTMLSelectElement>);
          }
        }
      } catch (error) {}
    };

    fetchData();
  }, []);
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/\D/g, "");

    // Azərbaycan nömrəsi üçün limit 9-dur (məs: 50 777 77 77)
    if (numericValue.length <= 9) {
      // Input-un dəyərini rəqəmlərlə yeniləyirik
      e.target.value = numericValue;
      onChange(e);
    }
  };

  return (
    <div className={styles.phoneInput}>
      {label && (
        <label className={styles.labelInput} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={styles.phoneInputGroup}>
        <select
          className={styles.phoneCodeSelect}
          value={selectedCode}
          onChange={onCodeChange}
          name="number_prefix"
        >
          {phonePrefixes.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>
        {/* { prefixError} */}
        <input
          type="tel"
          style={{color:'#000'}}
          id={id}
          name={name}
          // Braunzer səviyyəsində də 9 rəqəmdən artığına icazə vermirik
          maxLength={9}
          placeholder={placeholder}
          className={styles.liveSupportFormInput}
          value={value}
          onChange={handlePhoneChange}
        />
      </div>
      {error ? (
        <p
          className={`${styles.errorMessage} ${
            error ? styles.visible : styles.hidden
          }`}
        >
          {error}
        </p>
      ) : (
        <p className={styles.hidden}>empty</p>
      )}
    </div>
  );
};

export default PhoneInputComponent;
